import { Copy, Linkedin, ExternalLink, Check, MessageCircle, Archive } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { intelApi } from "../../lib/intelApi";

export default function ShareBar({ week, showOpen = true, showArchive = false }) {
  const [copied, setCopied] = useState(false);
  // Share URL goes through the backend so crawlers (LinkedIn/WhatsApp/X) get OG tags; humans are redirected to /brief/:week.
  const url = intelApi.shareUrl(week);
  const text = `This Week in Cloud Security — ${week}. My AI-ranked brief of what changed across AWS, Azure, GCP, Kubernetes, Terraform & GitHub.`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Public link copied.");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toast.error("Copy failed — link: " + url);
    }
  };

  const btn =
    "inline-flex items-center gap-2 border border-border px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] hover:border-accent hover:text-accent transition-colors";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-bar">
      <button type="button" onClick={copy} data-testid="share-copy-link" className={btn}>
        {copied ? <Check size={13} className="text-accent" /> : <Copy size={13} />} {copied ? "Copied" : "Copy link"}
      </button>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-linkedin"
        className={btn}
      >
        <Linkedin size={13} /> LinkedIn
      </a>
      <a
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-x"
        className={btn}
      >
        X
      </a>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp"
        className={btn}
      >
        <MessageCircle size={13} /> WhatsApp
      </a>
      {showOpen && (
        <Link to={`/brief/${week}`} data-testid="share-open-brief" className={`${btn} border-accent text-accent`}>
          <ExternalLink size={13} /> Public brief
        </Link>
      )}
      {showArchive && (
        <Link to="/briefs" data-testid="share-open-archive" className={btn}>
          <Archive size={13} /> All weeks
        </Link>
      )}
    </div>
  );
}
